import { render, staticRenderFns } from "./FooterShout.vue?vue&type=template&id=447a4bc3&scoped=true&"
import script from "./FooterShout.vue?vue&type=script&lang=js&"
export * from "./FooterShout.vue?vue&type=script&lang=js&"
import style0 from "./FooterShout.vue?vue&type=style&index=0&id=447a4bc3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447a4bc3",
  null
  
)

export default component.exports